import React,{ useState , useEffect} from 'react';
import FormContainer from '../components/FormContainer';
import { Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import CusFormCheckbox from '../components/CusFormCheckbox';
import CusProgressBar from '../components/CusProgressBar';
import config from '../appconfig/config.json';
import accopeningdata from '../data/accopeningdata.json'
import branchList from '../data/branch.json';
import sgdaccount from '../data/sgdaccount.json'
import sign from '../data/condofsign.json'
import frngaccount from '../data/foreignaccount.json'
import islamicFrngAcct from '../data/islamicforeignaccount.json'; //CR-Islamic Prod
import { FormInput,FormComboBox ,CusFormLabel, FormTitle, FormCheckbox, CusFormLabelTooltip} from '../validation/Form-Components';
import {othAlphaNumValidator, referralCodeValidator, reqDDLValidator} from '../validation/Validators';
import service from '../services/ApiService';
import { useHistory } from "react-router-dom";
import Loading from '../components/Loading';
import CusRadioButton from '../components/CusRadioButton';
import helper from '../factory/Helper.js';
import SubHeader from '../components/SubHeader';
import { filterBy } from "@progress/kendo-data-query";
import countriesrisk from '../data/countrieswealth.json';
import CusToast from '../components/CusToast';
import storage from '../factory/StorageFactory';

const configData = accopeningdata;
const purposesChkboxData = accopeningdata.purposesChkbox.data;
const countriesChkboxData = accopeningdata.countriesChkbox.data;
let branches = branchList;

const AccountOpening = (props) => {

    let timer; 
    const detailsType='1', compDtlsType ='0';
    const history = useHistory();
    const item = { bgcolor: "#389A6E", completed: 20 };
    const islamicUsdCurrentAcct = 'HG', usdCurrentAcct = 'UC';

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    
    const [response, setResponse] = useState();

    const [fCountries, setfCountries] = useState(countriesrisk.slice());  //filtered countries
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving, setIsSaving] = useState(false);
    const [selectedWealthOutSG, setSelectedWealthOutSG] = React.useState('Y');  //rdo WealthOutSG
    const [showPurposesOthDesc, setShowPurposesOthDesc] = React.useState(false);  // checkbox PurposesOthDesc
    const [showWealthCntyOth, setShowWealthCntyOth] = React.useState(false); // checkboxWealthCntyOth
    const [showBranchAddr,setShowBranchAddr] = useState(false);  // bank branch address
    const [branchObj, setBranchObj] = useState({"value":"","label":"","addr":""});

    const [showReqChequebook,setShowReqChequebook] = useState(false); //CR Chequebook

    //initialise the form data
    const [acctOpening, setAcctOpening] = useState({

        PrefBranch: '',
        PrefSGDAcct: '',
        PrefFrngAcct: '',
        ReqChequebook:'',
        ReqFrngAcctChequebook:'',

        LoanRepay:false,
        Transactional:false,
        Payroll:false,
        PurposesOth:false,
        PurposesOthDesc:'',

        WealthCntySG:false,
        WealthCntyBN:false,
        WealthCntyMY:false,
        WealthCntyCN:false,
        WealthCntyID:false,
        WealthCntyIN:false,
        WealthCntyOTH:false,
        WealthCntyOth:'',

        PrimaryBizAct:  '',
        SecondaryBizAct: '',
        
        ReferralCode:''
    })

    //CR-Islamic Prod
    const [frngAcctData, setFrngAcctData] = useState([]);

    useEffect(() => {

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href =  config.link.Cancle;
            return;
        }
        
        window.scrollTo(0,0);
        frngaccount.sort(helper.dynamicSort('label'));
 
        // getData();
        getFormData();
        return () => clearTimeout(timer);
     }, []);

     const getData = () => {
        setIsLoading(true);
        let url = helper.getBaseApiUrl();
        service.getBranches(url+'/rsme').then( res => {
            setIsLoading(true);
            branches = res.data;
            getFormData();
        })
        .catch(err => {
            console.log('@getBranches ',err);
            getFormData();
        })
    }

    const getFormData = () => {
        service.get().then( res =>{
            setIsLoading(false);
            if(res.data.isSucess){
                setResponse(res.data.model.fields.request);
                bindFormData(res.data.model.fields.request)
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=> {
            setIsLoading(false);
            showErrMsg(config.error.GetApiFailed);
        })
    }

    const bindFormData = (data) => {
        let PrefSGDAcctDDL = {};
        try{
            setShowBranchAddr(data.BizAccts.PrefBranch === null? false: true);
            setSelectedWealthOutSG(data.WealthOutSG === null || data.WealthOutSG === ''? 'Y':data.WealthOutSG);
            setShowPurposesOthDesc(data.PrpsAcctOpen.Oth === 'true'? true: false);
            setShowWealthCntyOth( data.WealthCnty.OTH  === 'true'? true: false);
            
            if(data.BizAccts.PrefSGDAcct && data.BizAccts.PrefSGDAcct !== null) {
                PrefSGDAcctDDL = getObjInArray(data.BizAccts.PrefSGDAcct,sgdaccount);
            }
            else {  //show default product type
                PrefSGDAcctDDL = getObjInArray(data.ProductType,sgdaccount);
            }

            //CR - Islamic Prod
            let foreginAccts = [];
            if(data.ProductType === sgdaccount[3].value) { //CAI
                foreginAccts = islamicFrngAcct;
            }
            else {
                foreginAccts = frngaccount;
            }

            setFrngAcctData(foreginAccts);
            if(data.BizAccts.PrefFrngAcct === islamicUsdCurrentAcct || data.BizAccts.PrefFrngAcct === usdCurrentAcct) {
                setShowReqChequebook(true);
            }
            else {
                setShowReqChequebook(false);
            }

            let reqFrngAcctChequebookValue;
            if(data.BizAccts.ReqForFrngAcctChequeBook === undefined || data.BizAccts.ReqForFrngAcctChequeBook === null || data.BizAccts.ReqForFrngAcctChequeBook === '') {
                reqFrngAcctChequebookValue = configData.reqChequebookDDL.data[1];
            }
            else {
                reqFrngAcctChequebookValue = getObjInArray(data.BizAccts.ReqForFrngAcctChequeBook, configData.reqChequebookDDL.data)
            }

      
            setAcctOpening({
                PrefBranch:data.BizAccts.PrefBranch === null? '': getObjInArray(data.BizAccts.PrefBranch, branches),
                PrefSGDAcct: PrefSGDAcctDDL,
                PrefFrngAcct: data.BizAccts.PrefFrngAcct === null? '': getObjInArray(data.BizAccts.PrefFrngAcct,foreginAccts),//CR- Islamic Prod
                CondOfSign:data.BizAccts.PrefFrngAcct === null? '': getObjInArray(data.BizAccts.CondOfSign, sign),
                ReqChequebook: data.BizAccts.ReqForChequeBook === null? configData.reqChequebookDDL.data[1]:getObjInArray(data.BizAccts.ReqForChequeBook, configData.reqChequebookDDL.data), //CR - Chequebook
                ReqFrngAcctChequebook:reqFrngAcctChequebookValue,
                
                LoanRepay:data.PrpsAcctOpen.LoanRepay === 'true'? true: false,
                Transactional:data.PrpsAcctOpen.Transactional === 'true'? true: false,
                Payroll:data.PrpsAcctOpen.Payroll === 'true'? true: false,
                PurposesOth:data.PrpsAcctOpen.Oth === 'true'? true: false,
                PurposesOthDesc: data.PrpsAcctOpen.OthDesc? data.PrpsAcctOpen.OthDesc:'',
        
                WealthCntySG: data.WealthCnty.SG  === 'true'? true: false, 
                WealthCntyBN: data.WealthCnty.BN  === 'true'? true: false,
                WealthCntyMY: data.WealthCnty.MY  === 'true'? true: false,
                WealthCntyCN: data.WealthCnty.CN  === 'true'? true: false,
                WealthCntyID: data.WealthCnty.ID  === 'true'? true: false,
                WealthCntyIN: data.WealthCnty.IN  === 'true'? true: false,
                WealthCntyOTH: data.WealthCnty.OTH  === 'true'? true: false,
                WealthCntyOth:data.WealthCnty.Country=== null? {}: getObjInArray(data.WealthCnty.Country, countriesrisk),
         
                PrimaryBizAct: data.PrimaryBizAct,
                SecondaryBizAct: data.SecondaryBizAct,

                ReferralCode: data.ReferralCode
            })
    
            setBranchObj(data.BizAccts.PrefBranch === null? branchObj: getObjInArray(data.BizAccts.PrefBranch, branches))

        } catch(ex) {
            
        }
    }

    const getObjInArray = (iValue, array) => {
        const result = array.find( ({ value }) => value === iValue);
        return result;
    }

    //bank branch selection
    const handlePrefBranch = (e) => {
        if(e.value === null){
            return;
        }
        setBranchObj(e.value);
        setShowBranchAddr(true);
    }

    const onClickBranchAddr = ( ) => {
        setShowBranchAddr(false);
    }

    const handleSubmit = (eve) => {

        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
        
        if(eve.isValid){
            let data = JSON.parse(JSON.stringify(eve.values));
           
            if(showWealthCntyOth && data.WealthCntyOth.value === undefined) {
                showErrMsg('Others: Select drop down list')
                return;
            }

            // console.log('formatJsonParams: ',formatJsonParams(data))
            saveAccountOpening(formatJsonParams(data));
        }
    }

    const handleBack = (e) => {
        e.preventDefault();
        let sid = storage.getStateId();
        history.push(config.route.CompanyDetails+'?state='+sid);
    }

    let formatJsonParams = function(data) {
      
        storage.setProductType(data.PrefSGDAcct.value);
 

        let reqFrngAcctChequebookValue ='';
        if(showReqChequebook) {
            reqFrngAcctChequebookValue = data.ReqFrngAcctChequebook !== null? data.ReqFrngAcctChequebook.value:'';
        }
        else {
            reqFrngAcctChequebookValue = '';
        }

        let params = {
            BizAccts: {
                PrefBranch: data.PrefBranch.value,
                PrefBranchDesc: data.PrefBranch.label,
                PrefSGDAcct: data.PrefSGDAcct.value,
                PrefFrngAcct: data.PrefFrngAcct !==null? data.PrefFrngAcct.value:'',
                PrefFrngAcctDesc:data.PrefFrngAcct !==null? data.PrefFrngAcct.label:'',
                ReqForChequeBook: 'N',  //CR - Chequebook - sunsetting
                ReqForFrngAcctChequeBook:reqFrngAcctChequebookValue   //CR - Chequebook
            },
            PrpsAcctOpen: {
                Transactional:data.Transactional,
                Payroll: data.Payroll,
                LoanRepay: data.LoanRepay,
                Oth:data.PurposesOth,
                OthDesc:data.PurposesOthDesc
            },
            WealthOutSG: selectedWealthOutSG,
            WealthCnty: {   
                SG: selectedWealthOutSG === 'Y'? false: data.WealthCntySG? true:false,
                BN: selectedWealthOutSG === 'Y'? false: data.WealthCntyBN? true:false,
                MY: selectedWealthOutSG === 'Y'? false: data.WealthCntyMY? true:false,
                CN: selectedWealthOutSG === 'Y'? false: data.WealthCntyCN? true:false,
                ID: selectedWealthOutSG === 'Y'? false: data.WealthCntyID? true:false,
                IN: selectedWealthOutSG === 'Y'? false: data.WealthCntyIN? true:false,
                OTH: selectedWealthOutSG === 'Y'? false: data.WealthCntyOTH? true:false,
                Country : selectedWealthOutSG === 'Y'? null: data.WealthCntyOTH? data.WealthCntyOth.value: null
            },
            ReferralCode: data.ReferralCode
        }

        return params;
     }

     const validatePrimaryBizAct = () => {
         if(acctOpening.PrimaryBizAct === null || acctOpening.PrimaryBizAct === '' || acctOpening.PrimaryBizAct === undefined) {
            return false;
         }
         return true;
     }

     const saveAccountOpening = (params) => {
     
        if(!validatePrimaryBizAct()){
            showErrMsg(config.error.MyInfo.MissingData);
            return;
        }

        if(selectedWealthOutSG === 'N'){
            if(!validateNoOfCheckedBox(params.WealthCnty,1,5)){
                showErrMsg(accopeningdata.chkboxErrMsg.WealthCnty+": "+config.error.SelectChk5);
                return;
            }
        }
        
        if(!validateNoOfCheckedBox(params.PrpsAcctOpen,1,4)){
            showErrMsg(accopeningdata.chkboxErrMsg.PrpsAcctOpen+": "+config.error.SelectChk1orMore);
            return;
        }

        setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess) {
               // saveCompanyDetails();
               goNext();
            }  
            else {
                showErrMsg(config.error.SaveApiFailed);
            }         
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
     }

     const saveCompanyDetails = () => {
        
        let params ={}

        if(response.RegBizMailAddr.SameAsRegBizAddr === 'Y'){
            params= {
                CurrentUser:currentUser(),
                ProductType:storage.getProductType(), //storage.getProductType()
                RegBizMailAddr:{
                    SameAsRegBizAddr: response.RegBizMailAddr.SameAsRegBizAddr,
                    CompTypeCode:response.RegBizMailAddr.CompTypeCode,
                    CompType:response.RegBizMailAddr.CompType
                }
            }
        }
        else{ 
            params = {
                CurrentUser:currentUser(),
                ProductType:storage.getProductType(), //storage.getProductType()
                RegBizMailAddr:{
                    SameAsRegBizAddr:response.RegBizMailAddr.SameAsRegBizAddr,  
                    AddType:config.addTypeLocal, 
                    BlkNo: response.RegBizMailAddr.BlkNo,
                    Street: response.RegBizMailAddr.Street,
                    FlrNum: response.RegBizMailAddr.FlrNum,
                    UnitNo: response.RegBizMailAddr.UnitNo,
                    BldName: response.RegBizMailAddr.BldName,
                    PostalCode: response.RegBizMailAddr.PostalCode,
                    Country: 'SG',
                    CompTypeCode:response.RegBizMailAddr.CompTypeCode,
                    CompType:response.RegBizMailAddr.CompType
                }
            }
        }

        service.post(compDtlsType,params).then(res=>{
            let resData = res.data;
            if(resData.isSucess) {
                goNext();
            }
            else {
                showErrMsg(resData.errorMessage);
            }   
        })
        .catch(err => {
            
            showErrMsg('Error: Save Failed!');
        });
    }

     const currentUser = () => {
        let params = {};
        params = {
            IDNum: response.ApplicantsDtlsMyInfo.IDNum,
            Seq:null
        }
        return params
    }


    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }
    
    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

     const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            history.push(config.route.TxnActivities);
        }
    }

     const validateNoOfCheckedBox = (data, min, max) => {
        let result = true;
        let count = 0;
        let dataArray =  Object.values(data);
     
        for(let i in dataArray){
            if(dataArray[i] === true){
                count++;
            }
        }
 
        if( count < min || count > max){
             result = false;
        }
        else{
            result = true;
        }
        
        return result;
     }

    //radio 
    const outsideSgRdoBtnChange =  React.useCallback(
        (e) => {
            setSelectedWealthOutSG(e.value);
            
        },
        [setSelectedWealthOutSG]
    );

    const filterData = (filter) => {
        const data = countriesrisk.slice();
        return filterBy(data, filter);
    };
    
    const filterWealthCntyChange = (event) => {
        setfCountries(filterData(event.filter));
    };

    const handlePrefFrngAcctOnChange = (e) => {
        
        const selectedFrngAcct = e.value;
        if(selectedFrngAcct === null) {
            setShowReqChequebook(false);
        }
        else {
            if(selectedFrngAcct.value === islamicUsdCurrentAcct || selectedFrngAcct.value === usdCurrentAcct) {
                setShowReqChequebook(true);
            }
            else {
                setShowReqChequebook(false);
            }
        }
      
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return(
        <div className="container-fluid">
            <SubHeader />
            <br/>

            <Form onSubmitClick={handleSubmit} 
                initialValues={acctOpening}
                key={JSON.stringify(acctOpening)}
                render={(formRenderProps)=>(
                    <FormElement>
                        <FormContainer>
                            <fieldset>
                                <Field component={FormTitle} id={'ft1'} name={configData.formContainerTitle[0].name}/> 

                                <FieldWrapper>
                                {!showBranchAddr?  
                                    <div className="row around-xs inputPair elementVisible" >
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{configData.branchAccountsDDL.lblname}</div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 example-col" >
                                            <div className="box">
                                                <Field id={'PrefBranch'} 
                                                    name={'PrefBranch'}
                                                    component={FormComboBox}
                                                    textField={'label'}
                                                    data={branches}
                                                    placeholder={'Please select'}
                                                    validator={reqDDLValidator}
                                                    onChange={handlePrefBranch} />
                                            </div>
                                        </div>
                                </div> : 
                                <div className="row around-xs inputPair elementVisible" >
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{configData.branchAccountsDDL.lblname}</div>
                                        </div>
                                  
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 example-col" >
                                            <div style={{boxSizing:'border-box',border: 'solid 0.1rem #D7D7D7',width:'100%',padding: '0.375rem 0.75rem',borderRadius: '0.25rem'}}>
                                                <div className="box" onClick={onClickBranchAddr}>
                                                    <div>{branchObj.label}</div>  
                                                    <div style={{fontSize:'12px',color:'grey',paddingTop:'5px'}}>{branchObj.addr}</div>
                                                </div>
                                            </div>
                                        </div>
                                </div>}
                                <div className="row around-xs inputPair elementVisible" >
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{configData.sgdCurrencyAccountDDL.lblname}</div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">
                                                <Field id={'PrefSGDAcct'} 
                                                    name={'PrefSGDAcct'}
                                                    component={FormComboBox}
                                                    textField={'label'}
                                                    data={sgdaccount}
                                                    placeholder={'Please select'}
                                                    validator={reqDDLValidator}
                                                    disabled={true} />
                                            </div>
                                        </div>
                                </div>
                                {/* CR - Chequebook*/}
                                {/*CR - Chequebook removal 01 oct 2025*/}
                                {/* <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box">
                                            <Field component={CusFormLabelTooltip} 
                                                id={'ft2'} name={configData.reqChequebookDDL.lblname}
                                                tooltipPosition={'right'} tooltipAchor={'target'} 
                                                tooltipTitle={configData.reqChequebookDDL.tooltipTxt} /> 
                                        </div>
                                    </div> 
                                    
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box">
            
                                            <Field id={'ReqChequebook'} 
                                                name={'ReqChequebook'}
                                                component={FormComboBox}
                                                textField={'label'}
                                                data={configData.reqChequebookDDL.data}
                                                validator={reqDDLValidator}
                                                placeholder={'Please select'} />
                       
                                        </div>
                                    </div>
                                </div> */}
                        

                                <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{configData.foreignCurrencyAccountDDL.lblname}
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">
                                                <Field id={'PrefFrngAcct'} 
                                                    name={'PrefFrngAcct'}
                                                    component={FormComboBox}
                                                    textField={'label'}
                                                    data={frngAcctData}
                                                    placeholder={'Please select'} 
                                                    onChange={handlePrefFrngAcctOnChange}
                                                    />
                                            </div>
                                        </div>
                                </div>

                                {/* CR - Chequebook*/}
                                {showReqChequebook &&
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box">
                                            <Field component={CusFormLabelTooltip} 
                                                id={'ft2'} name={configData.reqChequebookDDL.lblname}
                                                tooltipPosition={'right'} tooltipAchor={'target'} 
                                                tooltipTitle={configData.reqChequebookDDL.tooltipTxt} /> 
                                        </div>
                                    </div> 
                                    
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box">
                                            <Field id={'ReqFrngAcctChequebook'} 
                                                name={'ReqFrngAcctChequebook'}
                                                component={FormComboBox}
                                                textField={'label'}
                                                data={configData.reqChequebookDDL.data}
                                                validator={reqDDLValidator}
                                                placeholder={'Please select'} />
                                        </div>
                                    </div>
                                </div>
                             }
                             
                                </FieldWrapper>

                                <FieldWrapper></FieldWrapper>
                            </fieldset>
                        </FormContainer>
                        
                        <FormContainer>
                            <fieldset>
                                
                                <Field component={FormTitle} id={'ft1'} name={configData.formContainerTitle[1].name}/> 

                                <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="box">{configData.purposesChkbox.header}</div>
                                    </div>
                                    {purposesChkboxData.map((item, idx) => (
                                        <CusFormCheckbox key={idx} id={item.id} disabled={false}
                                                name={item.id} lblname={item.lblname} 
                                                onCheckedChange={(checkedValue,id)=>{ }}  /> 
                                        ))
                                    }

                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{paddingTop:'10px'}}>
                                        <div style={{width:'10%',float:'left'}}>
                                            <Field id={'PurposesOth'} name={'PurposesOth'} component={FormCheckbox} disabled={false}
                                                onChange={(e) => {
                                                    if(!e.value) {
                                                        formRenderProps.onChange('PurposesOthDesc', { value: '' });
                                                    }
                                                    setShowPurposesOthDesc(e.value);
                                            }} />
                                        </div>
                                        <div style={{width:'90%',float:'left',paddingTop:'10px'}}  >
                                            <Field 
                                                id={'PurposesOthDesc'}
                                                name={'PurposesOthDesc'} 
                                                placeholder={'Others'} 
                                                disabled={!showPurposesOthDesc}
                                                component={FormInput} 
                                                maxLength={80} 
                                                validator={showPurposesOthDesc? othAlphaNumValidator:''} />
                                        </div>
                                    </div>
                                </div>
                                </FieldWrapper>
                                <FieldWrapper></FieldWrapper>
                                <FieldWrapper>
                                <CusRadioButton name="SameAsRegBizAddr" leftValue='Y' rightValue='N' 
                                    label={configData.label.wealthOutSg}
                                    onChange={outsideSgRdoBtnChange} checkedValue={selectedWealthOutSG} 
                                    disabled={false} />
                                </FieldWrapper>
                                <FieldWrapper></FieldWrapper>

                                {selectedWealthOutSG==='N'? 
                                <div>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="box">{accopeningdata.countriesChkbox.header}
                                        </div>
                                    </div>
                                    {countriesChkboxData.map((item, idx) => (
                                        <CusFormCheckbox key={idx} id={item.id} lblname={item.lblname}
                                            onCheckedChange={(checkedValue, id)=>{
                                            }} />))
                                    }

                                        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{paddingTop:'10px'}}>
                                            <div style={{width:'10%',float:'left'}}>
                                                <Field id={'WealthCntyOTH'} name={'WealthCntyOTH'} component={FormCheckbox} disabled={false}
                                                    onChange={(e) => {
                                                        setShowWealthCntyOth(e.value);
                                                        if(!e.value){
                                                            formRenderProps.onChange('WealthCntyOth', { value: '' });
                                                        }
                                                }} />
                                            </div>
                                            <div style={{width:'90%',float:'left',paddingTop:'10px'}} >
                                                <Field id={'WealthCntyOth'} 
                                                    name={'WealthCntyOth'}
                                                    component={FormComboBox}
                                                    textField={'label'}
                                                    data={fCountries}
                                                    filterable={true}
                                                    onFilterChange={filterWealthCntyChange}
                                                    placeholder={'Others'}
                                                    disabled={!showWealthCntyOth}
                                                    validator={showWealthCntyOth? reqDDLValidator:''} />
                                            </div>  
                                        </div>

                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div style={{width:'8%',float:'left'}}>
                                                <Field id={'WealthCntyCN'} name={'WealthCntyCN'} component={FormCheckbox} disabled={false} />       
                                             </div>
                                            <div style={{width:'92%',float:'left'}}  className={'k-form-field'}>
                                                <label className={'k-checkbox-label'} >{'China'}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>:null}
                                
                                <FieldWrapper>
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblPrimaryBiz'} leftLabelName={accopeningdata.label.primaryBiz} 
                                    id={'PrimaryBizAct'} name={acctOpening.PrimaryBizAct !==null?acctOpening.PrimaryBizAct:''} />

                                        
                                <Field component={CusFormLabel} 
                                    leftLabelId={'lblSecdBiz'} leftLabelName={accopeningdata.label.secondBiz}
                                    id={'SecondaryBizAct'} name={acctOpening.SecondaryBizAct  !==null?acctOpening.SecondaryBizAct:'' } /> 
                                </FieldWrapper>   
                                <div style={{ paddingTop: "15px" }}> <hr className="greyPanelLine" /> </div>
                                <FieldWrapper>
                                    <Field component={FormTitle} id={'ft2'} name={configData.formContainerTitle[2].name}/> 
                                    <div className="row around-xs inputPair elementVisible">
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">{configData.ReferralTxt}</div>
                                            <div className="box">
                                                <div style={{fontSize:'12px',color:'grey'}}>
                                                    {configData.ReferralSubTxt}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="box">
                                                <Field 
                                                    id={'ReferralCode'}
                                                    name={'ReferralCode'}  
                                                    component={FormInput} 
                                                    maxLength={20} 
                                                    validator={referralCodeValidator} />
                                            </div>
                                        </div>
                                    </div>
                                </FieldWrapper>
                                
                               <FieldWrapper>
                                <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} />

                                <div className="row around-xs inputPair elementVisible">
                                    <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{paddingBottom: "20px"}}>
                                        <button type={'button'} className="btn btn-back" onClick={handleBack}>{config.btnName.Back}</button>
                                        <button type={'submit'} className="k-button btn btn-success btn-float-right" disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                                    </div>
                                </div> 
                                </FieldWrapper>

                             
                                <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 

                            </fieldset>
                        </FormContainer>
                    </FormElement>
                )}>
            </Form>
            {isSaving && <Loading />}      
        </div>
    )
}

export default AccountOpening;